import * as HttpStatus from 'http-status-codes';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslationMWService } from '@services/translation-middleware/translation-middleware.service';
import { ToastrService } from 'ngx-toastr';

export const serverError = (
  error: HttpErrorResponse,
  toastr: ToastrService,
  translationMWService: TranslationMWService
) => {
  const errorMessageLabel = 'server.error.message.'.concat(
    error.error.error.toLowerCase().replace(/\s/g, '-').replace(/'/g, '').replace(/\//g, '-')
  );
  toastr.error(translationMWService.instant(errorMessageLabel));
};

export const errorSavingInstallation = (
  error: HttpErrorResponse,
  toastr: ToastrService,
  translationMWService: TranslationMWService
) => {
  if ([HttpStatus.StatusCodes.CONFLICT, HttpStatus.StatusCodes.FORBIDDEN].includes(error.status)) {
    serverError(error, toastr, translationMWService);
  }
};
